import React, { useEffect, useState } from 'react'
import { Card, Table } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import api from '../helper/api';
import { getServerURL } from '../helper/envConfig';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const ContactUs = (props) => {

    const serverURL = getServerURL()
    const [searchText, setSearchText] = useState("");
    const [userData, setUserData] = useState([])
    const [loading, setLoading] = useState(true)
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    useEffect(() => {
        getUserData();
    }, [searchText, page]);

    const getUserData = (event) => {
        api.getWithToken(`${serverURL}user/contact-us-query/?page=${page}${searchText ? `&_s=${searchText}` : ""}`)
            .then(async (res) => {
                setLoading(false)
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                if (res?.data?.success === true) {
                    setUserData(data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                        </div>
                    </div>
                </Card.Header>

                <Card.Body>
                    <Table responsive hover className='product-table'>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(userData?.length) ? userData?.map((item, index) =>
                                    <tr>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <h6 className="m-0">{item?.first_name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.last_name || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.email || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.phone_number || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.message || "-"}</h6>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(userData?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }}
                />
            }
        </>
    )
}

export default ContactUs